export const URL_PATHS = {
  APPRAISAL_LANDING: '/appraisal/',
  APPRAISAL_PROMOTIONS_LANDING: '/appraisal/promotions/',
  SELL_CAR_LANDING: '/sell-car/',
  TMV_LANDING: '/tmv.html',
};

export const LANDING_URL_PATHS = [
  URL_PATHS.APPRAISAL_LANDING,
  URL_PATHS.APPRAISAL_PROMOTIONS_LANDING,
  URL_PATHS.SELL_CAR_LANDING,
  URL_PATHS.TMV_LANDING,
];

export const MULTI_OFFER_DMA_LIST_PATH = '/editorial/includes/offers/dmas';
